import React, { useEffect, useReducer, useState } from 'react'
import { connect, useSelector } from 'react-redux';
import FormValidator from '../../../../../utils/FormValidator';
import { enumUtil } from '../../../../../utils/Enum';
import isNull from '../../../../../utils/NullChecking';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../../Setup/Shared/ModalHeader';
import NotificationHandler from '../../../../../utils/NotificationHandler';
import { ServerRequestProtected } from '../../../../../utils/ServerDataRequest';
import Loader from '../../../../shared/Loader/Loader';
import DatePicker from '../../../../General/DatePicker';
import SuperSearchList from '../../../../shared/SuperSearch/SuperSearchList';
import handleNumericCheck from '../../../../../utils/HandleNumericKeys';
import { FindSecondChild } from '../../../../../utils/FindMenuOption';
import { TabActionPayments } from '../../../../../actions/BillingActions';
import useHandleOpenNewBrowserTab from '../../../../shared/NewTabBrowser/useHandleOpenNewBrowserTab';

const AddNewInsurancePayment = ({ addNewInsurancePayment, setAddNewInsurancePayment, ...props }) => {

    const handleOpenNewBrowserTab = useHandleOpenNewBrowserTab();
    const API_URL_GENERAL = enumUtil.controller.General
    let IsEditAllowedInurancePayment = FindSecondChild('Billing', 'Payments', 'Payments')?.IsAdd
    const API_URL = enumUtil.controller.Payment;
    let reduxInsuranceDD =
        useSelector(state => state.GeneralDropDownsReducer)?.Insurance?.filter(item => !['-1', -1, "SELFPAY"].includes(item.value));
    let insuranceDDData =
        props?.insuranceDD?.length > 0 ?
            props?.insuranceDD?.filter(item => !['-1', -1, "SELFPAY"].includes(item.value)) : reduxInsuranceDD;

    const [is, setIs] = useState(false);
    let Header_Data = {
        BPR_02_CheckAmount: null,
        BPR_16_CheckDate: null,
        DepositDate: null,
        TRNCheckNumber: '',
        InsuranceID: props?.InsuranceID || '',
        PostingStatus: '',
        SenderBankAccount: '',
        ReceiverBankAccount: '',
    }

    const PaymentMethodData = [
        { value: "ACH", display: "ACH - Automated Clearing House" },
        { value: "BOP", display: "BBOP - Financial Institution Option" },
        { value: "CHK", display: "CHK - Check" },
        { value: "FWT", display: "FWT - Federal Reserve Funds/Wire Transfer - Nonrepetitive" },
        { value: "NON", display: "NON - Non-Payment Data" },
    ];

    const [data, handleChange] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { HeaderData: Header_Data })
    const [isLoading, setIsLoading] = useState(false)

    let Search_Value = {
        InsuranceName: insuranceDDData?.find(ins => ins.value == props?.InsuranceID)?.InsuranceName || "",
        PaymentMethodName: "",
    }
    const [searchValue, setSearchValue] = useState(Search_Value);
    ///////////Save Validation/////////////
    let saveValModal = {}
    let SaveValidationModal = {
        // PaymentTypeVal: "",
        TRNCheckNumberVal: "",
        BPR_16_CheckDateVal: "",
        BPR_02_CheckAmountVal: "",
        PayerIDVal: "",
    };
    const [saveValidationModal, setSaveValidationModal] = useState(SaveValidationModal);

    useEffect(() => {
        if (!(insuranceDDData && insuranceDDData?.length > 0)) return;
        if (!(insuranceDDData?.find(ins => ins.value == props?.InsuranceID)?.InsuranceName)) return;
        setIs(true);
    }, [])


    const SaveValidation = async () => {
        const checkExists = await handleValidateCheckNumber(true); // Await the result
        let rawAmount = data.HeaderData.BPR_02_CheckAmount;
        let checkAmount = rawAmount != null && rawAmount !== "" && Number(rawAmount) === 0 ? "00": rawAmount;

        let SaveValidationModal = {
            PayerIDVal: FormValidator(
                searchValue.InsuranceName,
                enumUtil.enumValidationType.Required,
                'Payer',
            ),
            TRNCheckNumberVal: checkExists ?
                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                    <i className="bi bi-info-circle-fill fs-10"></i>
                    <p className="fs-9 text-white text">Check with this number already exists</p>
                </div> : FormValidator(
                    data.HeaderData.TRNCheckNumber,
                    enumUtil.enumValidationType.Required,
                    'Check Number',
                ),
            BPR_16_CheckDateVal: FormValidator(
                data.HeaderData.BPR_16_CheckDate,
                enumUtil.enumValidationType.Required,
                'Check Date',
            ),
            BPR_02_CheckAmountVal: FormValidator(
                checkAmount,
                enumUtil.enumValidationType.Required,
                'Check Amount',
            ),

        }
        await setSaveValidationModal(SaveValidationModal)
        saveValModal = SaveValidationModal
    }
    const CheckExistsValidation = async (exists) => {
        let SaveValidationModal = {
            ...saveValidationModal,
            TRNCheckNumberVal: exists ?
                <div className="invalid-feedback tool_tip d-flex align-items-center gap-1" style={{ display: "block" }}>
                    <i className="bi bi-info-circle-fill fs-10"></i>
                    <p className="fs-9 text-white text">Check with this number already exists</p>
                </div> : FormValidator(
                    data.HeaderData.TRNCheckNumber,
                    enumUtil.enumValidationType.Required,
                    'Check Number',
                ),

        }
        await setSaveValidationModal(SaveValidationModal)
        saveValModal = SaveValidationModal
    }
    const handleValidateCheckNumber = async (isReturn) => {
        try {
            const response = await ServerRequestProtected(API_URL + "/ValidateCheckNo", 'post', {
                "TableName": enumUtil.enumAPITableName.CheckDetails,
                "SearchParam": data.HeaderData.TRNCheckNumber,
            });

            if (response === "Check with this number already exists") {
                console.log("isReturn", isReturn);
                if (isReturn === true) return true;
                CheckExistsValidation(true);
                return true; // Ensure we return true for this case
            } else {
                if (isReturn === true) return false;
                CheckExistsValidation(false);
                return false; // Ensure we return false for this case
            }
        } catch (error) {
            console.error("Error validating check number:", error);
            if (isReturn === true) return false; // Default return on error
            setIsLoading(false);
            return false; // Ensure we return false on error
        }
    };
    const handleSearchChange = (e) => {
        setIs(false);
        let { name, value } = e.target;
        if (name === "InsuranceID") {
            setSearchValue({ ...searchValue, InsuranceName: value });
        }
        if (name === "PaymentMethod") {
            setSearchValue({ ...searchValue, PaymentMethod: value });
        }
        // if (!isNull(value)) {
        //     setinsuranceBody({ "TableName": enumUtil.enumAPITableName.Insurance, "SearchParam": value })
        // }
    };
    /////////////////////////////////////////
    const handleCalendarChange = (date, name, type) => {
        var FormatedDate = date
        let modal = { ...data[type] };
        modal[name] = FormatedDate
        handleChange({ [type]: modal })
    }
    const handleInputChange = (e, type) => {
        let { name, value } = e.target;
        let modal = { ...data[type] };
        if (name === 'BPR_02_CheckAmount') {
            // Sanitize the value (e.g., remove commas) if needed
            modal[name] = value.replace(/,/g, '');

        } else {
            modal[name] = value
        }
        handleChange({ [type]: modal })
    }
    /////////////////////////////////////////
    const handleSelectedData = (selectedData, name, type) => {
        setIs(true);
        if (!isNull(selectedData)) {
            if (type === "client") {
                if (name === "InsuranceID" && !isNull(selectedData)) {
                    setSearchValue({ ...searchValue, InsuranceName: selectedData.display });
                    let modal = { ...data['HeaderData'] };
                    modal[name] = selectedData.value.toString()
                    handleChange({ 'HeaderData': modal })
                }
                if (name === "PaymentMethod" && !isNull(selectedData)) {
                    setSearchValue({ ...searchValue, PaymentMethodName: selectedData.display });
                    let modal = { ...data['HeaderData'] };
                    modal[name] = selectedData.value.toString()
                    handleChange({ 'HeaderData': modal })
                }
            } else if (type === "server") {
                if (name === "InsuranceID") {
                    setSearchValue({ ...searchValue, InsuranceName: selectedData.display });
                    let modal = { ...data['HeaderData'] };
                    modal[name] = selectedData.value.toString()
                    handleChange({ 'HeaderData': modal })
                }
            }
        } else {
            if (name === "InsuranceID") {
                setSearchValue({ ...searchValue, InsuranceName: '' })
                let modal = { ...data['HeaderData'] };
                modal[name] = ''
                handleChange({ 'HeaderData': modal })
            }
        }
        return selectedData;
    };
    const AddManualPayment = (type) => {
        if (type === 'Insurance') {
            handleSave();
        }
        else if (type === 'Patient') { }
    }
    ////////////////////////////////////////
    const handleSaveHeaderData = (response) => {
        response['ID'] = response.id;
        response['CheckNumber'] = data.HeaderData.TRNCheckNumber;
        response['Type'] = 'Manual';
        OpenPayments(response);
        setAddNewInsurancePayment(false);
        handleChange({ 'HeaderData': Header_Data })
        setSearchValue(Search_Value)
    }
    const OpenPayments = (data, accordType, activeERATab) => {
        let dataObj = {
            name: 'Payments',
            data: {
                id: String(data?.ID),
                name: data?.CheckNumber,
                checkType: "Manual",
            }
        };

        handleOpenNewBrowserTab(dataObj);

        // let obj = {
        //     key: 2,
        //     name: "Payments",
        //     active: true,
        //     data: {
        //         id: data.ID,
        //         name: data.CheckNumber,
        //         time: new Date(),
        //         checkType: data.Type,
        //         accordionType: accordType,
        //         activeERATab: activeERATab,
        //     },
        // };
        // console.log("OpenPaymentsDataobj", obj)
        // props.TabActionPayments(obj);
    }

    const handleSaveModal = () => {
        const modal = {
            "Header": {
                "ID": "0",
                "data": data.HeaderData
            },
        };
        return modal;
    }
    const handleSave = async () => {
        await SaveValidation();
        let saveValidation = FormValidator([saveValModal], enumUtil.enumValidationType.NullCheck)
        if (saveValidation) {
            NotificationHandler('Fill required Data', enumUtil.enumtoaster.error)
            return
        } else {
            let modal = handleSaveModal();
            setIsLoading(true);
            ServerRequestProtected(API_URL_GENERAL + "/SaveManualPosting", 'post', {
                ...modal
            })
                .then((response) => {
                    setIsLoading(false);
                    NotificationHandler("Record Saved", enumUtil.enumtoaster.success);
                    if (response.id) {
                        handleSaveHeaderData(response);
                    }
                }).catch((error) => {
                    setIsLoading(false);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                })
        }
    }
    const addHeader = (name) => {
        return <p style={{ color: '#434343', fontFamily: 'Poppins', fontWeight: '600', margin: '0', fontSize: '12px' }}>{`Add ${name} Payment`}</p>;
    };

    return (

        <Modal show={addNewInsurancePayment} onHide={addNewInsurancePayment} backdrop="static" keyboard={false} dialogClassName="app-modal hk-modal-v1 modal-lg add_insurance_modal">
            <Modal.Body>
                {isLoading ? <Loader /> : null}
                {/*<SearchHeader masterListButton={addNewInsurancePayment} /> */}
                <ModalHeader DeletePopup={""} HeaderName={() => addHeader('Insurance')} isClosed={() => {
                    setAddNewInsurancePayment(false); setSaveValidationModal(SaveValidationModal);
                }} key={631} Name={'AddInsurancePayment'} />
                <div className="add_insurance_modal old-validation-design">
                    <div className={` input ${saveValidationModal.TRNCheckNumberVal ? "error" : ""}`}>
                        <label >Check #<span className='req'>*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            id="TRNCheckNumber"
                            name="TRNCheckNumber"
                            value={data.HeaderData.TRNCheckNumber}
                            onChange={(e) => handleInputChange(e, 'HeaderData')}
                            onBlur={handleValidateCheckNumber}
                        />
                        {saveValidationModal.TRNCheckNumberVal}
                    </div>
                    <div className={` input ${saveValidationModal.BPR_16_CheckDateVal ? "error" : ""}`}>
                        <DatePicker
                            label={<>Check Date<span className='req'>*</span></>}
                            className={`${saveValidationModal.BPR_16_CheckDateVal ? "mb-0" : ""}`}
                            value={data.HeaderData.BPR_16_CheckDate}
                            maxDate={new Date()}
                            handleCalendarChangefunc={(e) => handleCalendarChange(e, 'BPR_16_CheckDate', 'HeaderData')}
                        />
                        {saveValidationModal.BPR_16_CheckDateVal}
                    </div>
                    <div className={`input ${saveValidationModal.BPR_02_CheckAmountVal ? "error" : ""}`}>
                        <label className="">Check Amount<span className='req'>*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            id="BPR_02_CheckAmount"
                            name="BPR_02_CheckAmount"
                            value={data.HeaderData.BPR_02_CheckAmount}
                            onChange={(e) => handleInputChange(e, 'HeaderData')}
                            onKeyPress={(event) => handleNumericCheck(event, 'decimal')}
                        />
                        {saveValidationModal.BPR_02_CheckAmountVal}
                    </div>
                    <div className={`d-flex flex-column input ${saveValidationModal.PayerIDVal ? "error" : ""}`}>
                        <label className="">Payer<span className='req'>*</span></label>
                        <SuperSearchList
                            type="client"
                            id="InsuranceID"
                            name="InsuranceID"
                            searchValue={searchValue.InsuranceName}
                            data={insuranceDDData}
                            onChange={handleSearchChange}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                            // isReadOnly={isReadOnly}
                            placeholder={false}
                            inputError={saveValidationModal.PayerIDVal}
                        />
                        {saveValidationModal.PayerIDVal}
                    </div>
                    <div className={`d-flex flex-column input`}>
                        <label className="">Payment Method</label>
                        <SuperSearchList
                            type="client"
                            id="PaymentMethod"
                            name="PaymentMethod"
                            searchValue={searchValue.PaymentMethodName}
                            data={PaymentMethodData}
                            onChange={handleSearchChange}
                            getSelectedData={handleSelectedData}
                            is={is}
                            sup_btn='sup_btn-Inp'
                            sup_inp='superSearchVisitInp'
                            // isReadOnly={isReadOnly}
                            placeholder={false}
                        // inputError={saveValidationModal.PayerIDVal}
                        />
                        {/* {saveValidationModal.PayerIDVal} */}
                    </div>
                    <div className="input">
                        <DatePicker
                            label='Deposit Date'
                            value={data.HeaderData.DepositDate}
                            maxDate={new Date()}
                            handleCalendarChangefunc={(e) => handleCalendarChange(e, 'DepositDate', 'HeaderData')} />
                    </div>
                    <div className="input">
                        <label className="">Sender Bank Account #</label>
                        <input
                            type="text"
                            className="form-control py-0"
                            id="SenderBankAccount"
                            name="SenderBankAccount"
                            value={data.HeaderData.SenderBankAccount}
                            onChange={(e) => handleInputChange(e, 'HeaderData')}
                            onKeyPress={(event) => handleNumericCheck(event)}
                        />
                    </div>
                    <div className="input">
                        <label className="">Receiver Bank Account #</label>
                        <input
                            type="text"
                            className="form-control py-0"
                            id="ReceiverBankAccount"
                            name="ReceiverBankAccount"
                            value={data.HeaderData.ReceiverBankAccount}
                            onChange={(e) => handleInputChange(e, 'HeaderData')}
                            onKeyPress={(event) => handleNumericCheck(event)}
                        />
                    </div>
                </div>
                {/* <div className="tabs-action-bottom">
                    <div className="btns-group text-end pt-2 br-top-1 br-clr d-flex align-items-center justify-content-end h-100">
                        <button className={IsEditAllowedInurancePayment ? "btn btn-orange p-1 d-flex align-items-center justify-content-center gap-01" : "btn btn-orange disabled"} onClick={() => AddManualPayment('Insurance')}>Proceed <i className="icon-arrow-right2"></i></button>
                    </div>
                </div> */}
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className={IsEditAllowedInurancePayment ? "btn btn-validate px-10 h-100 p-1 d-flex align-items-center justify-content-center gap-01" : "btn btn-validate px-10 h-100 disabled"} onClick={() => AddManualPayment('Insurance')}>Proceed <i className="icon-arrow-right2"></i></button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

function mapStateToProps(state) {
    return {
        OpenDynamicTab: state.Open_Payment_Tab ? state.Open_Payment_Tab : [],
        Settings: state.SettingsReducer,
    };
}
const action = {
    TabActionPayments,
};
export default connect(mapStateToProps, action)(AddNewInsurancePayment);